import { useEffect, useState } from "react";

/**
 * يراقب الأقسام على الصفحة ويعيد id القسم الظاهر حاليًا
 * threshold 0.5: عندما يظهر 50% من القسم تقريبًا
 */
export default function useActiveSection(sectionIds = []) {
  const [active, setActive] = useState(sectionIds[0] || null);

  useEffect(() => {
    const elements = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    if (!elements.length) return;

    const obs = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible?.target?.id) setActive(visible.target.id);
      },
      { threshold: 0.5, rootMargin: "0px 0px -20% 0px" }
    );

    elements.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionIds.join("|")]);

  return active;
}
